import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	readQRCodeButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[700]),
		color: colors.gray[0],
		borderRadius: 4,
		padding: 8,
		width: "100%",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[800])
		}
	},
	informNumberButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		color: colors.purple[600],
		borderRadius: 4,
		padding: 8,
		width: "100%",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[200])
		}
	},
	saveButtonDialog: {
		width: "95%",
		borderRadius: 4,
		padding: 8,
		marginLeft: "0 !important"
	},
	secondaryButtonDialog: {
		width: "95%",
		borderRadius: 4,
		padding: 8,
		marginLeft: "0 !important"
	},
	dialogActions: {
		display: "flex",
		flexDirection: "column-reverse",
		gap: 8
	}
}))

export default useStyles
